<template>
    <div class="drawer drawer-right drawer-filter dw-xs-10 dw-sm-6 dw-md-3 fold" aria-labelledby="drawer-filter">
        <div class="drawer-contents">

            <div class="drawer-heading">
                <h2 class="drawer-title">
                    Filter Time & Material Projects
                </h2>
                <a href=".drawer-filter" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-filter" class="btn btn-close-drawer">
                    <i class="far fa-times"></i>
                </a>
            </div><!-- /.drawer-heading -->

            <div class="drawer-body">
                <h3>Show</h3> 
                
                <div class="form-group form-group-material">
                    <div class="checkbox checkbox-primary">
                        <input id="checkbox-show-archived" type="checkbox" v-model="filters.archived"> 
                        <label for="checkbox-show-archived">Archived</label>
                    </div>
                </div> 
                
            </div>

        </div><!-- /.drawer-contents -->
    </div><!-- /.drawer -->

</template>

<style>
    .form-control {
        box-shadow: none !important;
    }

    .form-control[readonly] {
        background-color: transparent !important;
    }
</style>

<script>

    import { mapActions, mapState } from 'vuex'
    import { http } from 'utils'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import Multiselect from 'vue-multiselect'

    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: ['filters'],
        components: {
            Selectize,
            LaddaButton,
            Datepicker,
            Multiselect
        }
    }
</script>
